module.exports = __webpack_public_path__ + "img/close.7e42f52b.svg";